<app-show-summary [summary]="summary" (closeEvent)="closeModal($event)"></app-show-summary>
